import Vue from 'vue'
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: { show: false, activeindex: 0 }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/productcenter/index.vue'),
    meta: { show: false, activeindex: 1 }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/aboutus/index.vue'),
    meta: { show: false, activeindex: 2 }
  },
  {
    path: '/businessmovement',
    name: 'businessmovement',
    component: () => import('@/views/businessmovement/index.vue'),
    meta: { show: false, activeindex: 3 }
  },
  {
    path: '/hiring',
    name: 'hiring',
    component: () => import('@/views/joinus/index.vue'),
    meta: { show: false, activeindex: 4 }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contactus/index.vue'),
    meta: { show: false, activeindex: 5 }
  },
  // 英文版路由
  {
    path: '/en',
    redirect: '/en/index'
  },
  {
    path: '/en/index',
    name: 'en-index',
    component: () => import('@/views/en/index.vue'),
    meta: { show: false, activeindex: 0 }
  },
  {
    path: '/en/products',
    name: 'en-products',
    component: () => import('@/views/en/products.vue'),
    meta: { show: false, activeindex: 1 }
  },
  {
    path: '/en/about',
    name: 'en-about',
    component: () => import('@/views/en/about.vue'),
    meta: { show: false, activeindex: 2 }
  },
  {
    path: '/en/contactUs',
    name: 'en-contactUs',
    component: () => import('@/views/en/contactUs.vue'),
    meta: { show: false, activeindex: 3 }
  },
  // 404 页面可选
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return { selector: to.hash, behavior: 'smooth' }
    return { x: 0, y: 0 }
  }
})

// 避免重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 路由守卫
router.beforeEach((to, from, next) => {
  // 去掉尾斜杠，除了根目录
  let path = to.path;
  // 去掉尾斜杠
  if (path.endsWith('/') && path !== '') {
    path = path.replace(/\/+$/, ''); // 去掉所有尾斜杠
    next({ path, replace: true });
    return;
  }

  if (Vue.prototype.$bus) {
    Vue.prototype.$bus.$emit("nextaboutitem", to.meta.activeindex)
  }

  // 找不到匹配路由 → 跳首页
  if (to.matched.length === 0) {
    next('/index')
  } else {
    next()
  }
})

export default router
